export enum Events {
  AktivtReferat = "Klikker på aktivt referat",
  BehandlePersonopplysninger = "Klikker på les mer om behandling av personopplysninger",
  Brodsmule = "Klikker på brødsmule",
  DocumentRendererLink = "Klikker på lenke i selve brevet",
  KontaktAndreMoter = "Klikker på kontakt oss på andre måter",
  KontaktOss = "Klikker på kontakt oss",
  LastNedReferat = "Klikker på last ned referat",
  LenkeIReferat = "Klikker på info url i referat",
  LesMerOmDialogmoter = "Klikker på les mer om dialogmøter",
  LesOmHvordanDeltaVideomote = "Klikker på les om hvordan delta i videomote",
  MeldBehov = "Klikker på meld behov",
  MeldBehovKvittering = "Klikker på kvittering meld behov",
  Oppfolgingsplan = "Klikker på oppfølgingsplan",
  SeAvlysning = "Klikker på se avlysning av innkalling",
  SeEndring = "Klikker på se endring av innkalling",
  SeInnkalling = "Klikker på se innkalling",
  SendMeldBehov = "Klikker på send meld behov",
  SendSvarBehov = "Klikker på send svar behov",
  SvarBehov = "Klikker på svar behov",
  SvarBehovKvittering = "Klikker på kvittering svar behov",
  TidligereReferat = "Klikker på et tidligere referat",
  Tidslinjen = "Klikker på tidslinjen",
  SendSvarPaInnkallelse = "Klikker på send svar på møteinnkallelse",
  GiSvarPaMoteInnkallingVist = "Viser gi svar pa moteinnkalling",
  SpillerAvDialogmotefilm = "Klikker på spill av film om dialogmøte",
  ErrorWithEscapeRoute = "Klikker på naviger bort fra feilside.",
}
